import {Stack} from "@mui/material";
import ContentBox from "./ContentBox";
import React from "react";
import {useTranslation} from "react-i18next";

export interface LastSystemStateProps {
    resetTag: number;
}
export default function LastSystemState(props: LastSystemStateProps) {
    const {t} = useTranslation();
    const {resetTag} = props;
    return (
        <Stack direction="column">
            <ContentBox>
                {t("deviceHistory_ResetTag")}: {resetTag}
            </ContentBox>
        </Stack>
    );
}
